import { FC } from "react";
import SubmittedDocumentsSection from "../../IRB/IRBSubmission/CreateIRBSubmission/IRBSubmission/SubmittedDocumentsSection";
import { DOCUMENTS } from "../../../../constants/forms";

const ECSubmissionSAE: FC = (): JSX.Element => {

  return (
    <SubmittedDocumentsSection
      fieldName={DOCUMENTS}
      labelText="2.1  Documents Submitted - EC"
    />
  );
};

export default ECSubmissionSAE;
